export default "__VITE_ASSET__bzmO_0JQ__"